export enum DEFAULT_SORTING_KEYS {
    WITHOUT = '',
    RATING_DESC = 'rating-desc',
    BESTSELLER_RATING = 'bestseller-rating',
    CREATED_AT_DESC = 'created-at-desc',
    FEATURED_DESC = 'author-featured-desc',
    PRICE_ASC = 'price-asc',
    PRICE_DESC = 'price-desc',
    BEST_SELLERS_DESC = 'best-sellers-desc',
    VOTES_DESC = 'votes-desc'
}
